<!--  -->
<template>
 <div class="workDetail">
    <crumbs detail="true"/>
    <div class="container">
      <div class="leftPart">
        <div class="topBox">
           <div class="statusIcon"
            :class="{
              icon0:status.code === 1,
              icon1:status.code=== 0,
              icon2:status.code ===2
            }"
           >
           {{status.description}}
          </div>
          <div class="title">
            <h2>{{params.activityName}}</h2>
            <div class="bro">
              <pv pvtype="1" :count="pv" pv-style="iconpv1"/>
            </div>
          </div>
          <div class="types">
            <span v-if="types !== '' && types !== undefined">{{types}}</span>
          </div>

          <div class="infos">
              <img :src="getImage(params.cover)" alt="">
              <div class="infobox">
                  <p v-if="Number(actNumLimit)===1"><span>剩余：</span>{{surplusWorksCount}}/{{params.actNumber}}</p>
                  <p v-if="params.startDate !=='' && params.startDate !== undefined"><span>日期：</span>{{getSplit(params.startDate)}}</p>
                  <p><span>发起：</span>{{params.sponsorUnit}}</p>
                  <div class="enroll" v-if="params.voteType" @click="goAdd()">我要参加</div>
                  <div class="enroll vote" v-if="!params.voteType">活动已结束</div>
              </div>
          </div>
        </div>
        <div class="chooseBtn" @click="clicks($event)">
          <span class="active" @click="showBox=true">活动详情</span>
          <span @click="showBox=false">作品赏析</span>
        </div>
        <div class="botBox botBox1" v-show="showBox">
            <div class="tips" v-if="tip !== '' ">
                  <div class="tit"> *温馨提示：</div>
                  <div class="cont" v-html="tip">
                  </div>
            </div>
            <div class="contents"  v-html="params.content">

            </div>
         <comment v-if="params" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"> </comment>
        </div>
        <div class="botBox botBox2" v-show="showBox === false">
            <input type="hidden" :value="params.voteType">
            <workItem :activityId="id" :voteType="params.voteType"></workItem>
        </div>
      </div>

      <div class="rightPart">
          <div class="tit">
              <span>活动推荐</span>
              <span @click="goList()">更多> </span>
          </div>

          <ul class="lists">
            <li v-for="item in dataList" :key="item.id" v-if="item.id != id">
              <img :src="getImage(item.cover)" alt="">
              <p>{{item.activityName}}</p>
            </li>
          </ul>
      </div>
    </div>
    <right-sidebar
          @pvcount="pvcount"
          :comment-count="commentTotal"
          :comment-gotop="commentOffsettop"
          :comment-show="isCommentshow"
          :title="params.activityName"
          :image="getImage(params.cover)"
          :url="this.$route.fullPath"
          ref="rightSidebar"></right-sidebar>
        <go-top></go-top>
 </div>
</template>

<script>
import workItem from '@/components/worksItem/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import pv from '@/components/amount/pv'
import {getWorkDetail, getWorkList, getCdian} from '@/api/workCollect/index'
import crumbs from '@/components/crumbs/index'
export default {
  name: 'workCollectDetail',
  components: {
    crumbs,
    Comment,
    workItem,
    RightSidebar,
    goTop,
    pv
  },
  meta: {
    showHeader: true
  },
  // filters: {
  //   getSplit (val) {
  //     return val.split(' ')[0]
  //   }
  // },
  data () {
    return {
      actNumLimit: 1,
      id: '',
      isCommentshow: true,
      commentTotal: '',
      commentOffsettop: '',
      showBox: true,
      params: {},
      pv: 0,
      params1: {
        page: 1,
        limit: 3,
        menuId: '',
        activityType: null,
        dateType: null,
        status: null
      },
      dataList: [],
      columnId: '',
      types: '',
      tip: '',
      surplusWorksCount: '',
      status: {}
    }
  },
  created () {
    this.actNumLimit = this.$route.query.actNumLimit
    this.status = this.$route.query.statu
    console.log(this.$route.query.statu.code, 'sss')
    this.surplusWorksCount = this.$route.query.surplusWorksCount
    this.id = this.$route.query.id
    this.columnId = this.$route.query.columnId
    this.params1.menuId = this.$route.query.columnId
    this.getWorkDetail()
    this.getWorkList()
    this.getCdian()
  },
  methods: {
    getSplit (val) {
      return val.split(' ')[0]
    },
    getCdian () {
      const pp = {
        menuId: this.columnId,
        dictParentCode: 'watlx,wwplx'
      }
      getCdian(pp).then(res => {
        // console.log(res)
        let hd = res.data.data.dictType.watlx.list
        let tip = res.data.data.dictType.wwplx.list
        let mjs = hd.find(item => {
          return item.dictCode === this.params.activityType
        })
        let mjs1 = tip.find(item => {
          return item.dictCode === this.params.tips
        })
        this.types = mjs.dictName
        this.tip = mjs1.description
      })
    },
    getWorkDetail () {
      getWorkDetail(this.id).then(res => {
        console.log(res)
        this.params = res.data.data
        let nowdate = new Date()
        let dataendTime = new Date(res.data.data.endDate.replace(/-/g, '/'))
        if (nowdate.getTime() > dataendTime.getTime()) {
          this.params.voteType = false
        } else {
          this.params.voteType = true
        }
      })
    },
    getWorkList () {
      getWorkList(this.params1).then(res => {
        // console.log(res)

        this.dataList = res.data.data.rows
      })
    },
    clicks (e) {
      console.log(e.target)
      let childs = e.target.parentNode.childNodes
      for (var i = 0; i < childs.length; i++) {
        if (childs[i].nodeName === 'SPAN') {
          childs[i].classList.remove('active')
          console.log(childs[i].classList)
        }
      }
      e.target.classList.add('active')
    },
    goList () {
      this.$router.push({
        path: '/workCollect',
        query: {columnId: this.columnId}
      })
    },
    goAdd () {
      if (this.surplusWorksCount === '0') {
        this.$alert('报名人数已满', '', {
          confirmButtonText: '确定'
        })
      } else {
        if (this.$cookie.get('wlyuserid') === undefined || this.$cookie.get('wlyuserid') === null) {
          this.$router.push({path: '/login', query: {redirect: this.$router.currentRoute.fullPath}})
        } else {
          this.$router.push({
            path: 'addNew',
            query: {
              activityId: this.params.id,
              columnId: this.columnId
            }
          })
        }
      }
    },
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/works.scss'
</style>



// WEBPACK FOOTER //
// src/view/workCollect/detail.vue